import { render } from "./PrescriptionRenewModal.vue?vue&type=template&id=1cabcbc8"
import script from "./PrescriptionRenewModal.vue?vue&type=script&lang=js"
export * from "./PrescriptionRenewModal.vue?vue&type=script&lang=js"

import "./PrescriptionRenewModal.vue?vue&type=style&index=0&id=1cabcbc8&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__